/**
 * registry-lang-switcher.js — task #557
 *
 * A language picker in the Gift Registry builder header. The registry builder
 * ships as localized sibling pages (/gift-registry-v2.html, /es/…, /he/…, …),
 * so switching language means navigating to the sibling for the same page while
 * PRESERVING the query string (the registry id) and hash. Self-injecting so one
 * <script> tag on each localized copy is all that's needed.
 */
(function () {
    'use strict';

    var LANGS = [
        { code: 'en', label: 'English', prefix: '' },
        { code: 'es', label: 'Español', prefix: '/es' },
        { code: 'fr', label: 'Français', prefix: '/fr' },
        { code: 'de', label: 'Deutsch', prefix: '/de' },
        { code: 'pt', label: 'Português', prefix: '/pt' },
        { code: 'he', label: 'עברית', prefix: '/he' },
        { code: 'ar', label: 'العربية', prefix: '/ar' }
    ];

    // Current language from the path prefix (NOT <html lang> — that is the page's
    // authored language, which is what we want here anyway, but the path is the
    // source of truth for where we ARE).
    function currentCode() {
        var seg = window.location.pathname.split('/')[1];
        for (var i = 0; i < LANGS.length; i++) {
            if (LANGS[i].prefix === '/' + seg) return LANGS[i].code;
        }
        return 'en';
    }

    // The path with any leading locale prefix stripped — e.g. /es/gift-registry-v2.html
    // → /gift-registry-v2.html.
    function basePath() {
        var p = window.location.pathname;
        var seg = p.split('/')[1];
        for (var i = 0; i < LANGS.length; i++) {
            if (LANGS[i].prefix && LANGS[i].prefix === '/' + seg) {
                return p.slice(LANGS[i].prefix.length) || '/';
            }
        }
        return p;
    }

    function urlFor(code) {
        var lang = LANGS.filter(function (l) { return l.code === code; })[0];
        if (!lang) return null;
        return lang.prefix + basePath() + window.location.search + window.location.hash;
    }

    function build() {
        var row = document.querySelector('.app-header .app-header-row');
        if (!row || document.getElementById('registryLangSwitch')) return;

        var cur = currentCode();
        var curLabel = (LANGS.filter(function (l) { return l.code === cur; })[0] || LANGS[0]).code.toUpperCase();

        var wrap = document.createElement('div');
        wrap.className = 'reg-lang';
        wrap.id = 'registryLangSwitch';
        wrap.innerHTML =
            '<button type="button" class="reg-lang-btn" aria-haspopup="true" aria-expanded="false" aria-label="Change language">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>' +
            '<span class="reg-lang-code">' + curLabel + '</span>' +
            '<svg class="reg-lang-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
            '</button>' +
            '<div class="reg-lang-menu" role="menu">' +
            LANGS.map(function (l) {
                return '<a href="' + urlFor(l.code) + '" class="reg-lang-opt' + (l.code === cur ? ' is-current' : '') +
                    '" data-code="' + l.code + '" role="menuitem" hreflang="' + l.code + '"' +
                    (/^(he|ar)$/.test(l.code) ? ' dir="rtl"' : '') + '>' + l.label + '</a>';
            }).join('') +
            '</div>';
        row.appendChild(wrap);

        var btn = wrap.querySelector('.reg-lang-btn');
        var menu = wrap.querySelector('.reg-lang-menu');
        function close() { wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var open = !wrap.classList.contains('open');
            wrap.classList.toggle('open', open);
            btn.setAttribute('aria-expanded', String(open));
        });
        document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
        // Remember the choice the way the rest of the app does, so the landing
        // switcher and this one agree on a returning host's language.
        menu.addEventListener('click', function (e) {
            var opt = e.target.closest('.reg-lang-opt');
            if (opt) { try { localStorage.setItem('userLanguagePreference', opt.dataset.code); } catch (_) {} }
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
    else build();
})();
